import type { AddressVerificationRequest, AddressVerificationResponse } from "@credit-acceptance/step6-bff-client";
import { useMutation } from "@tanstack/react-query";

import { addressVerificationApi } from "../../../../../api/client";

/**
 * Mutation hook for verifying/standardizing a single address slot (address-
 * standardization-spec.md §5). Backed by AddressVerificationApi.verifyAddress
 * (POST /api/v1/workbench/addresses/verify). No query-key caching — each Save
 * attempt's per-slot gate (useAddressVerificationGate) calls `mutateAsync`
 * directly for a one-shot verify, not cacheable data like useZipLookup.
 * @returns {ReturnType<typeof useMutation>} The TanStack Mutation result.
 */
export function useVerifyAddress() {
  return useMutation({
    mutationFn: async (request: AddressVerificationRequest): Promise<AddressVerificationResponse> => {
      const response = await addressVerificationApi.verifyAddress(request);
      return response.data;
    },
  });
}
